import script from "./DatePickerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DatePickerComponent.vue?vue&type=script&setup=true&lang=js"

import "./DatePickerComponent.vue?vue&type=style&index=0&id=209f9032&lang=css"

const __exports__ = script;

export default __exports__